<!-- Navbar Start -->
<nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark navbar-light bg-dark" id="navbar">
    <div class="container">
        <!-- LOGO -->
        <a class="navbar-brand logo" routerLink="/">
            <img src="assets/logos/aa_white.png" alt="ArgoApps" class="logo-light" height="31">
            <img src="assets/logos/aa.png" alt="ArgoApps" class="logo-dark" height="31">
        </a>
        <div class="ml-auto">
            <a routerLink="/" class="btn btn-sm btn-outline-light"><i class="mdi mdi-arrow-left mr-1"></i> Volver al Inicio</a>
        </div>
    </div>
</nav>
<!-- Navbar End -->

<!-- Hero Start -->
<section class="hero-2-bg position-relative d-flex align-items-center bg-gradient-primary py-5" id="policy-header" style="min-height: 280px; padding-top: 110px !important;">
    <div class="hero-2-bg-overlay"></div>
    <div class="container position-relative" style="z-index: 2;">
        <div class="row justify-content-center text-center">
            <div class="col-lg-10">
                <span class="badge badge-warning text-dark px-3 py-2 mb-3 font-weight-bold f-14">rentasCR App</span>
                <h1 class="text-white font-weight-normal mb-3">Políticas de Privacidad y Uso de <span class="text-warning font-weight-bold">rentasCR</span></h1>
                <p class="text-white-70 f-16 mb-0">Términos, condiciones y protección de datos personales de la plataforma rentasCR.</p>
            </div>
        </div>
    </div>
    <div class="hero-bottom-img">
        <img src="assets/images/hero-2-shape.png" alt="" class="img-fluid d-block w-100 mx-auto">
    </div>
</section>
<!-- Hero End -->

<!-- Content Section Start -->
<section class="section bg-light" id="policy-content">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="card border-0 shadow-sm p-4 p-md-5 rounded-lg bg-white">
                    <p class="text-muted f-16 line-height-1_6 mb-4">
                        En <strong>rentasCR</strong>, valoramos tu privacidad y nos comprometemos a regular el uso adecuado de nuestra plataforma. Estas políticas detallan cómo recopilamos y tratamos tus datos personales, así como las responsabilidades asumidas al utilizar nuestros servicios.
                    </p>

                    <hr class="my-4">

                    <div class="policy-section mb-4">
                        <h5 class="font-weight-bold text-dark mb-3"><span class="text-warning mr-2">1.</span> Aceptación de Términos y Responsabilidad del Usuario</h5>
                        <p class="text-muted f-15 line-height-1_6">
                            Al descargar, registrarte o utilizar el aplicativo <strong>rentasCR</strong>, aceptas de manera expresa todos los términos de estas políticas. Al incluir datos en la aplicación (tales como tu nombre, correo electrónico, número de teléfono, fotografías y detalles de propiedades), aceptas y declaras que eres el único responsable de la veracidad y legalidad de los datos que se incluyan, así como del uso que se les dé a estos.
                        </p>
                    </div>

                    <div class="policy-section mb-4">
                        <h5 class="font-weight-bold text-dark mb-3"><span class="text-warning mr-2">2.</span> Información Recopilada</h5>
                        <p class="text-muted f-15 line-height-1_6">
                            Recopilamos información personal básica durante el registro (nombre, correo) y de forma voluntaria al completar tu perfil y tus anuncios de alquiler (número telefónico, ubicación y descripción de propiedades).
                        </p>
                    </div>

                    <div class="policy-section mb-4">
                        <h5 class="font-weight-bold text-dark mb-3"><span class="text-warning mr-2">3.</span> Compartición de Información</h5>
                        <p class="text-muted f-15 line-height-1_6">
                            Tus datos de contacto (como tu teléfono y ubicación si decides agregarlos) se mostrarán a otros usuarios que deseen consultarte sobre tus alquileres, saliendo del entorno privado del app bajo tu consentimiento.
                        </p>
                    </div>

                    <div class="policy-section mb-4">
                        <h5 class="font-weight-bold text-dark mb-3"><span class="text-warning mr-2">4.</span> Seguridad</h5>
                        <p class="text-muted f-15 line-height-1_6">
                            Implementamos medidas de seguridad para proteger tus datos contra el acceso no autorizado o alteración de tus datos personales.
                        </p>
                    </div>

                    <div class="policy-section mb-4 p-4 rounded bg-light border-left-warning" style="border-left: 4px solid #ff9800;">
                        <h5 class="font-weight-bold text-dark mb-3"><span class="text-warning mr-2">5.</span> Exención Total de Responsabilidad</h5>
                        <p class="text-muted f-15 line-height-1_6">
                            El desarrollador de la aplicación y <strong>ARGOAPPS</strong> quedan totalmente libres de toda responsabilidad civil, penal, contractual o de cualquier otra índole por el uso inadecuado que los usuarios puedan dar a la plataforma.
                        </p>
                        <p class="text-dark font-weight-medium f-15 mb-2">El usuario asume la responsabilidad total y completa por peligros y riesgos tales como:</p>
                        <ul class="text-muted f-15 line-height-1_6 pl-4 mb-3">
                            <li class="mb-2">Estafas, fraudes o engaños en las negociaciones de alquiler.</li>
                            <li class="mb-2">Publicación de imágenes inapropiadas, ilegales o de contenido de carácter pornográfico (lo cual está terminantemente prohibido y resultará en la eliminación inmediata de la cuenta).</li>
                            <li class="mb-2">Información falsa, robada o engañosa provista por personas inescrupulosas.</li>
                            <li class="mb-2">Robos, hurtos o cualquier daño a la integridad física, moral o patrimonial derivado del contacto presencial o virtual con otros usuarios de la aplicación.</li>
                        </ul>
                        <p class="text-muted f-15 line-height-1_6 mb-0">
                            <strong>rentasCR</strong> funciona únicamente como un canal de contacto, por lo que recomendamos encarecidamente verificar la identidad de sus contrapartes y tomar todas las medidas de precaución necesarias.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Content Section End -->

<!-- Footer Start -->
<app-footer></app-footer>
<!-- Footer End -->
